import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { auth } from '../firebase';
import { Link } from 'react-router-dom';

import { Nav, NavItem, NavLink } from 'reactstrap';

class Footer extends Component {

  render() {
    const { authUser, path } = this.props;

    return (
      <div className="bg-white">
        <footer className='footer container py-3 px-4 px-lg-5 d-flex justify-content-between'>
          <img src='/imgs/paul_logo_gray_text.svg' style={{width: 'auto', height: '40px'}}/>
          <Nav className="flex-column flex-sm-row">
            <NavItem>
              <small className="nav-link">© 2018</small>
            </NavItem>
            <NavItem>
              <NavLink href='https://twitter.com/paulopensearch' target='_blank'>Twitter</NavLink>
            </NavItem>
            <NavItem>
              <Link to='/about' className='nav-link'>Über uns</Link>
            </NavItem>
            <NavItem>
              <NavLink href="/imprint">Impressum</NavLink>
            </NavItem>
          </Nav>
        </footer>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  authUser: state.authUser,
  path: props.location.pathname
});

export default withRouter(connect(mapStateToProps)(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.js